// extracted by mini-css-extract-plugin
module.exports = {"MessageBlock":"MessageBlock_MessageBlock__oG1By","container":"MessageBlock_container__PzHJF","title":"MessageBlock_title__Yhcz3","description":"MessageBlock_description__uM1l2"};